import { IDataHandler } from '../IDataHandler';
import { FTUXTrackingEventName, allTrackingEvents } from '../TrackingEvent';
import { FTUXDataSet } from '../DataSet/FTUX';

type tDataSetKey = keyof FTUXDataSet;

export const FTUXDataMap: Map<allTrackingEvents, tDataSetKey[]> = new Map<
    allTrackingEvents,
    tDataSetKey[]
>([[FTUXTrackingEventName.ftux, ['stepId', 'stepName', 'ftuxVersion']]]);

export class FTUXDataHandler implements IDataHandler<FTUXDataSet> {
    public data: FTUXDataSet = new FTUXDataSet();

    public getEventData(eventName: allTrackingEvents): FTUXDataSet {
        const data = FTUXDataMap.get(eventName).reduce((acc, key) => {
            acc[key] = this.data[key] as never;
            return acc;
        }, {} as FTUXDataSet);

        // Reset data.
        if (eventName === FTUXTrackingEventName.ftux) {
            this.data = new FTUXDataSet();
        }

        return data;
    }

    public clearData(): void {
        this.data = new FTUXDataSet();
    }
}
